<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { OrderSummaryRow } from "@core/schema/OrderSummaryRow.js";
	import { getTariffsPath } from "@core/schema/paths/getTariffsPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./CartSummaryTable.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();

	const {
		rows,
		tarriffWarning,
	}: {
		rows: OrderSummaryRow[];
		tarriffWarning: boolean;
	} = $props();
</script>

<div class="flex flex-col">
	{#each rows as { label, value }, i (i)}
		<div class="flex justify-between py-5 text-fcrdarkgray font-medium border-b border-fcrgray-100/12">
			<div>{label}</div>
			<div class={[i === rows.length - 1 && "font-bold text-4.5"]}>{value}</div>
		</div>
	{/each}
	{#if tarriffWarning}
		<div class="py-5 text-fcrgray font-medium">
			<Formatted
				text={translate("tariffNotice", {
					url: getTariffsPath(tenant),
				})}
			/>
		</div>
	{/if}
</div>
